import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';

import { RouterModule } from '@angular/router';
import { MaterialModule } from './material.module';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { ContactService } from './services/contact.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [ 
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    TextFieldModule,
    NgxMaskModule.forChild(),
    HttpClientModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    TextFieldModule,
    NgxMaskModule
  ],
  providers: [  
    ContactService,
  ],
  declarations: [
  ]
})
export class SharedModule { }
